import { AutoFindTicketModel } from '../../logic/models';
import { StateCreatorWithDevtools } from '../store-utils';

// INFO: New sale

export interface PromoStoreSlice {
    
    /** Tell the component that we currently in an hidden promo page. i.e. with an rst-prv param. */
    hiddenPromo: boolean,
    setHiddenPromo: (hiddenPromo: boolean) => void,

    /** Used by the top sale component. Check if this is really need in the future. Could it be just a state? Or an event emitter. */
    onPromoUpdatedCallback: () => void,
    setOnPromoUpdatedCallback: (cb: () => void) => void;

}

export const PromoStoreSliceDef: StateCreatorWithDevtools<PromoStoreSlice, PromoStoreSlice> = (set, _get) => {
    return {
        hiddenPromo: false,
        setHiddenPromo: (hiddenPromo: boolean) => set({ hiddenPromo }, false, "hiddenPromo"),

        onPromoUpdatedCallback: null,
        setOnPromoUpdatedCallback: (cb) => set({ onPromoUpdatedCallback: cb }, false, "onPromoUpdatedCallback"),
    };
};

